var classes = {"overlayMenuCategory":"muZTc","overlayMenuCategoryCTA":"BREK-","overlayMenuCategoryTitle":"Y8ip4","overlayMenuCategoryOpen":"WFLCP","overlayMenuCategoryLinks":"cfjcS","overlayMenuCategoryLinksLink":"EosB-","iconTransitionArrowClosed":"VxcqM","iconTransitionArrowOpen":"-ECJU","overlayMenuCategoryTitleLink":"bGfiv","arrowDownIcon":"GiCqj"};

export { classes as default };
